import React, { useMemo } from 'react';
import { SectionTreeNodeDataProps } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { backgroundInlineStyles, BACKGROUND_SRC_DEFAULT_CLASSES } from './backgroundInlineStyles';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';
import { cn } from '../../utils/cn';

type SectionProps = {
  id: string;
  children?: React.ReactNode;
  editorClassName?: string;
  staticAssetsBaseURL?: string | null;
  isEditor?: boolean;
} & SectionTreeNodeDataProps &
  React.ComponentPropsWithRef<React.ElementType>;

function SectionInner(
  {
    id,
    as,
    className,
    editorClassName,
    children,
    backgroundSrc,
    staticAssetsBaseURL,
    isEditor = false,
    ...props
  }: SectionProps,
  ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
) {
  const style = useMemo(
    () => backgroundInlineStyles(backgroundSrc, staticAssetsBaseURL),
    [backgroundSrc, staticAssetsBaseURL],
  );

  return (
    <section
      id={id}
      ref={ref}
      data-flexible-page-section
      className={cn(
        backgroundSrc ? BACKGROUND_SRC_DEFAULT_CLASSES : undefined,
        transformToContainerQueries(className, { isEditor }),
        editorClassName,
      )}
      {...props}
      style={style}
    >
      {children}
    </section>
  );
}

SectionInner.displayName = 'Section';

export const Section = React.forwardRef<React.ComponentPropsWithRef<React.ElementType>['ref'], SectionProps>(
  SectionInner,
);
